import MembershipsSummary from '../../../reports/membership/MembershipSummary';

const MembershipNewChart = () => <MembershipsSummary />;

export default MembershipNewChart;
